import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
var withTranslation = function withTranslation(Component) {
  var Translated = /*#__PURE__*/function (_React$Component) {
    _inherits(Translated, _React$Component);
    var _super = _createSuper(Translated);
    function Translated() {
      _classCallCheck(this, Translated);
      return _super.apply(this, arguments);
    }
    _createClass(Translated, [{
      key: "translateIfNeeded",
      value: function translateIfNeeded(key) {
        if (!key || !this.context || !this.context.translateFromContext) {
          return key;
        }
        return this.props.shouldTranslate ? this.context.translateFromContext(key) : key;
      }
    }, {
      key: "render",
      value: function render() {
        var props = _.assign({}, this.props, {
          translateIfNeeded: this.translateIfNeeded.bind(this)
        });
        return /*#__PURE__*/React.createElement(Component, props);
      }
    }]);
    return Translated;
  }(React.Component);
  Translated.contextTypes = {
    translateFromContext: PropTypes.func
  };
  Translated.propTypes = {
    shouldTranslate: PropTypes.bool
  };
  Translated.defaultProps = {
    shouldTranslate: true
  };
  Translated.displayName = Component.displayName;
  return Translated;
};
export default withTranslation;